/**
 *
 * FlexBox
 *
 */

import React, { forwardRef } from 'react';
// import PropTypes from 'prop-types';
// import styled from 'styled-components';

import { FormattedMessage } from 'react-intl';
import messages from './messages';
import styles from './flexbox.module.css';
import lodash from 'lodash';

const FlexBox = forwardRef(function FlexBox(props, ref) {
  const {
    raised, // Boolean:         Makes the FlexBox appear raised with a shadow effect.
    bordered, // Boolean:         Adds a border around the FlexBox.
    guttered, // Boolean:         If true, adds gutters on all sides of the FlexBox
    contained, // Boolean:         If true, prevents overflow in both directions
    vstretch, // Boolean:         If true, directs the FlexBox to stretch vertically
    hstretch, // Boolean:         If true, directs the FlexBox to stretch horizontally
    rightGutter, // Boolean:         If true, adds a gutter on the right side
    bottomGutter, // Boolean:         If true, adds a gutter on the bottom side
    leftGutter, // Boolean:         If true, adds a gutter on the left side
    topGutter, // Boolean:         If true, adds a gutter on the top side
    fill, // Boolean:         If true, stretches both vertically and horizontally.  Equivalent to setting both hstretch=true and vstretch=true
    vcompress, // Boolean:         Applies min-height: 0px which is required for certain browsers with flexbox stretching vertically
    hcompress, // Boolean:         Applies min-width: 0px which is required for certain browsers with flexbox stretching horizontally
    background, // Color:           Sets a background color on the FlexBox.
    position, // CSS Prop:        Shorthand for CSS 'position' property.
    flex, // CSS Prop:        Shorthand for CSS 'flex' property
    align, // CSS Prop:        Shorthand for CSS 'align-items' property
    justify, // CSS Prop:        Shorthand for CSS 'justify-content' property
    row, // CSS Prop:        Shorthand for setting the FlexBox up for arranging elements in a row
    column, // CSS Prop:        Shorthand for setting the FlexBox up for arranging elements in a column
    wrap, // CSS prop:        Shorthand for applying CSS 'flex-wrap: wrap'
    basis, // CSS Prop:        Shorthand for CSS 'flex-basis' property
    title, // HTML Attribute:  Set the 'title' attribute on the <div> of the FlexBox
    id, // HTML Attribute:  Sets the 'id' attribute on the <div> of the FlexBox
    gutter, // Number:          Set the gutter size in use
    children, // Collection:      The incoming collection of React component children within this element
    style, // Object:          Passed in custom styles to apply to the FlexBox
    childBleed, // Boolean:         If true, allows children to overflow the FlexBox
    onDoubleClickCapture,
  } = props;
  let elemStyle = style ? lodash.cloneDeep(style) : {};
  let gutterSize = gutter ? gutter : 10;
  if (row) {
    elemStyle.flexDirection = 'row';
  } else if (column) {
    elemStyle.flexDirection = 'column';
  }

  if (flex) {
    elemStyle.flex = flex;
  }

  if (align) {
    elemStyle.alignItems = align;
  }

  if (justify) {
    elemStyle.justifyContent = justify;
  }

  if (wrap) {
    elemStyle.flexWrap = 'wrap';
  }

  if (basis) {
    elemStyle.flexBasis = basis;
  }

  if (rightGutter || guttered) {
    elemStyle.paddingRight = gutterSize;
  }

  if (bottomGutter || guttered) {
    elemStyle.paddingBottom = gutterSize;
  }

  if (leftGutter || guttered) {
    elemStyle.paddingLeft = gutterSize;
  }

  if (topGutter || guttered) {
    elemStyle.paddingTop = gutterSize;
  }

  if (fill) {
    elemStyle.height = '100%';
    elemStyle.width = '100%';
  }

  if (vstretch) {
    elemStyle.height = '100%';
    elemStyle.overflowY = 'auto';
  }

  if (hstretch) {
    elemStyle.width = '100%';
  }

  if (props.width) {
    elemStyle.width = props.width;
  }

  if (vcompress) {
    elemStyle.minHeight = '0';
  }

  if (hcompress) {
    elemStyle.minWidth = '0';
  }

  if (contained) {
    elemStyle.overflow = 'hidden';
  }

  if (position) {
    elemStyle.position = position;
  }

  if (bordered) {
    elemStyle.border = '1px solid var(--background-accent-color)';
    elemStyle.borderRadius = props.borderRadius ? props.borderRadius : '5px';
  }

  if (background) {
    elemStyle.background = background;
    elemStyle.borderRadius = props.borderRadius ? props.borderRadius : '5px';
  }

  if (raised) {
    elemStyle.boxShadow = '0px 1px 10px rgba(0,0,0,0.075), 0px 0px 0px 1px rgba(0,0,0,0.05)';
  }

  if (childBleed) {
    elemStyle.overflow = 'visible';
  }

  elemStyle.display = 'flex';
  let classes;
  if (props.className) {
    classes = `${styles.flexBox} ${props.className}`;
  } else {
    classes = `${styles.flexBox}`;
  }

  let handlers = props.handlers ? props.handlers : {};

  return (
    <div
      ref={ref}
      title={title}
      {...handlers}
      id={id}
      className={classes}
      style={elemStyle}
      onDoubleClickCapture={onDoubleClickCapture}
      dangerouslySetInnerHTML={props.dangerouslySetInnerHTML}
    >
      {children}
    </div>
  );
});

FlexBox.propTypes = {};

export default FlexBox;
